import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setEtapaSessionCapitalFlow } from 'services/authentication/auth';
import carteiraHome from '../../assets/img/carteiraHome.svg';
import dadosHome from '../../assets/img/dadosHome.svg';
import docHome from '../../assets/img/docHome.svg';
import moneyHome from '../../assets/img/moneyHome.svg';
import { useMenuSidebar } from '../../contexts/MenuSidebarContext';
import {
  getBancosAgenciasFinanceiro,
  getBoletosPendentesFinanceiro,
  getEmpresasDashboardFinanceiro,
  getInformacoesSaldo,
  getInstrucoesPendentesFinanceiro,
  getListaInformacoesIniciais,
  getRemessasPendentesFinanceiro,
  getTitulosPendencias,
  getValorOperado,
  listarFavoritos
} from '../../api/autenticacao';
import { SUBMENUS } from '../Shared/Enums/SubMenusEnum';
import {
  deleteRegistrosTemporarios,
  getEtapaCapitalFlow,
  getValorLiberadoCapitalFlow
} from '../../api/capitalFlow';

const useTypewriter = ({ typingSpeed = 8, multiPhrase = false, onFinish }) => {
  const [phrases, setPhrases] = useState([]);
  const [charIndex, setCharIndex] = useState(0);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [typing, setTyping] = useState(false);
  const containerRef = useRef(null);
  const tokensRef = useRef([]);
  const charIndexRef = useRef(0);

  const startTyping = newPhrases => {
    setPhrases(newPhrases);
    setCharIndex(0);
    setPhraseIndex(0);
    charIndexRef.current = 0;
    tokensRef.current = [];
    setTyping(true);
    if (containerRef.current) containerRef.current.innerHTML = '';
  };

  useEffect(() => {
    if (!typing || !phrases[phraseIndex] || !containerRef.current) return;

    const container = containerRef.current;
    const phrase = phrases[phraseIndex];

    if (tokensRef.current.length === 0) {
      const regex = /(<[^>]+>[^<]*<\/[^>]+>)|(<[^>]+>)|([^<]+)/g;
      let match;
      const parts = [];
      while ((match = regex.exec(phrase))) {
        if (match[1]) parts.push(match[1]);
        else if (match[2]) parts.push(match[2]);
        else if (match[3]) parts.push(...match[3].split(''));
      }
      tokensRef.current = parts;
    }

    const tokens = tokensRef.current;
    const currentCharIndex = charIndexRef.current;
    const token = tokens[currentCharIndex];

    let line = container.querySelector(`#phrase-${phraseIndex}`);
    if (!line) {
      line = document.createElement('div');
      line.id = `phrase-${phraseIndex}`;
      line.className = `phrase-${phraseIndex}`;
      const cursor = document.createElement('span');
      cursor.className = 'cursor-texto-gerado';
      line.appendChild(cursor);
      container.appendChild(line);
    }

    const cursor = line.querySelector('.cursor-texto-gerado');

    const timeout = setTimeout(() => {
      if (!token || !cursor) return;

      cursor.insertAdjacentHTML('beforebegin', token);
      charIndexRef.current++;
      setCharIndex(charIndexRef.current);

      if (charIndexRef.current >= tokens.length) {
        if (cursor) cursor.remove();

        if (multiPhrase && phraseIndex < phrases.length - 1) {
          setTimeout(() => {
            setPhraseIndex(prev => prev + 1);
            charIndexRef.current = 0;
            setCharIndex(0);
            tokensRef.current = [];
          }, 500);
        } else {
          setTyping(false);
          onFinish?.();
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, phraseIndex, phrases, typing, typingSpeed, multiPhrase, onFinish]);

  return {
    ref: containerRef,
    startTyping,
    typing
  };
};

const useHomeHook = ({ escopoAcesso, setEscopoAcesso }) => {
  const [esperandoValor, setEsperandoValor] = useState(false);
  const [valorFrase, setValorFrase] = useState(false);
  const [isPendingSaldo, setIsPendingSaldo] = useState(false);
  const [isPendingValorOperado, setIsPendingValorOperado] = useState(false);
  const [isPendingQtdPendencias, setIsPendingQtdPendencias] = useState(false);
  const [listaDeFavoritos, setListaDeFavoritos] = useState([]);
  const { excluirTelaAtual, user } = useMenuSidebar();
  const [loadingFavoritos, setLoadingFavoritos] = useState(false);
  const [nomeUsuario, setNomeUsuario] = useState(false);
  const [permissaoTelaPagamentos, setPermissaoTelaPagamentos] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [controleTamanho, setControleTamanho] = useState(3);
  const [valorSaldoOperar, setValorSaldoOperar] = useState(0);
  const [valorSaldoLiberado, setvalorSaldoLiberado] = useState(0);
  const [valorSaldoOperado, setValorSaldoOperado] = useState(0);
  const [qtdPendencias, setQtdPendencias] = useState(0);
  const [gerente, setGerente] = useState(false);
  const [plataforma, setPlataforma] = useState(false);
  const [unidadeNegocio, setUnidadeNegocio] = useState(false);
  const [vertical, setVertical] = useState(false);
  const [nivelUsuario, setNivelUsuario] = useState(false);
  const [loadingValorLiberado, setLoadingValorLiberado] = useState(false);
  const [loadingBuscaEtapa, setLoadingBuscaEtapa] = useState(false);
  const [openModalRecuperaCessao, setOpenModalRecuperaCessao] = useState(false);
  const [nomeEtapaCapitalFlow, setNomeEtapaCapitalFlow] = useState('');
  const [loadingDashboardFinanceiro, setLoadingDashboardFinanceiro] = useState(false);
  const [dashboardEmpresasAbertas, setDashboardEmpresasAbertas] = useState({});
  const [dashboardEmpresasCarregando, setDashboardEmpresasCarregando] = useState({});
  const [dashboardEmpresasCarregadas, setDashboardEmpresasCarregadas] = useState({});
  const [empresasDashboardHome, setEmpresasDashboardHome] = useState([]);
  const [empresasDashboardCarregadas, setEmpresasDashboardCarregadas] = useState(false);
  const navigate = useNavigate();

  const { ref: refNomeRef, startTyping: startTypingNome } = useTypewriter({
    multiPhrase: true,
    onFinish: () => setEsperandoValor(false)
  });

  const getSaudacao = () => {
    const hora = new Date().getHours();
    if (hora < 12) return 'Bom dia';
    if (hora < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  useEffect(() => {
    if (user && !nomeUsuario) {
      setNivelUsuario(user.nivel);
      setTimeout(() => {
        const nome = user.apelido ?? user.nome;
        setNomeUsuario(nome);
        startTypingNome([
          `${getSaudacao()}, <b>${nome}!</b>`,
          'Boas vindas à plataforma! Sua jornada está pronta para começar. 🚀'
        ]);
      }, 500);
    }
  }, [user]);

  useEffect(() => {
    excluirTelaAtual();
    buscaListaFavoritos();
    buscaInformacoesSaldo();
    buscaInformacoesIniciais();
    buscaValorLiberadoCapitalFlow();
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if ((gerente, plataforma, unidadeNegocio, vertical)) {
      buscaValorOperado();
      buscaTitulosPendencias();
    }
  }, [gerente, plataforma, unidadeNegocio, vertical]);

  useEffect(() => {
    if (esperandoValor && valorFrase && user) {
      setEsperandoValor(false);
      startTypingValor([valorFrase]);
      setValorFrase(null);
    }
  }, [esperandoValor, valorFrase, user]);

  useEffect(() => {
    setDashboardEmpresasAbertas(prevState =>
      empresasDashboardHome.reduce(
        (acc, empresa) => ({
          ...acc,
          [empresa.id]: prevState[empresa.id] ?? false
        }),
        {}
      )
    );
  }, [empresasDashboardHome]);

  const buscaInformacoesSaldo = () => {
    setIsPendingSaldo(true);
    getInformacoesSaldo()
      .then(response => {
        const permisaoTela = response?.data?.ACESSO_TELA === 'S';
        let saldoOperar = response?.data?.VALOR_DISPONIVEL || 0;
        setPermissaoTelaPagamentos(permisaoTela);
        saldoOperar = parseFloat(saldoOperar).toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        setValorSaldoOperar(saldoOperar);
      })
      .catch(err => {
        console.error('Erro ao buscar informações do saldo', err);
      })
      .finally(() => setIsPendingSaldo(false));
  };

  const buscaValorOperado = () => {
    setIsPendingValorOperado(true);
    const params = {
      anoMes: new Date().toISOString().slice(0, 7),
      gerente: gerente,
      plataforma: plataforma,
      unidadeNegocio: unidadeNegocio,
      vertical: vertical
    };
    getValorOperado(params)
      .then(response => {
        let saldoOperarado = response?.data?.totalVOP || 0;
        saldoOperarado = parseFloat(saldoOperarado).toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        setValorSaldoOperado(saldoOperarado);
      })
      .catch(err => {
        console.error('Erro ao buscar informações do saldo operado', err);
      })
      .finally(() => setIsPendingValorOperado(false));
  };

  const buscaTitulosPendencias = () => {
    setIsPendingQtdPendencias(true);
    const params = {
      gerente: gerente,
      plataforma: plataforma,
      vertical: vertical
    };
    getTitulosPendencias(params)
      .then(response => {
        let qtdPdc = response.data ?? 0;
        qtdPdc = parseFloat(qtdPdc).toLocaleString('pt-br', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        setQtdPendencias(qtdPdc);
      })
      .catch(err => {
        console.error('Erro ao buscar informações das pendências', err);
      })
      .finally(() => setIsPendingQtdPendencias(false));
  };

  const buscaInformacoesIniciais = () => {
    getListaInformacoesIniciais()
      .then(response => {
        const dados = response.data ?? [];

        const lstPlataformas = verificarLsts(dados?.lstPlataformas, 'CODAGENCIA', 'todas');
        setPlataforma(lstPlataformas);

        const lstBrokers = verificarLsts(dados?.lstGerentesplataforma, 'codBroker', 'todos', true);
        setGerente(lstBrokers);

        const lstUnidadesNegocios = verificarLsts(
          dados?.lstUnidadesNegocios,
          'codUnidadeNegocio',
          'todos',
          true
        );
        setUnidadeNegocio(lstUnidadesNegocios);

        const lstVerticais = verificarLsts(dados?.lstVerticais, 'CODVERTICALNEGOCIO', 'todas', true);
        setVertical(lstVerticais);
      })
      .catch(err => {
        console.error('Erro ao buscar informações das pendências', err);
      });
  };

  const verificarLsts = (array, campo, valorTodos, primeiroResultado = false) => {
    const contemTodos = array.some(item => item[campo] === valorTodos);
    if (contemTodos) {
      return valorTodos;
    }

    if (primeiroResultado) {
      return array[0][campo];
    }

    return [...new Set(array.filter(item => item[campo] !== valorTodos).map(item => item[campo]))];
  };

  const buscaListaFavoritos = () => {
    setLoadingFavoritos(true);
    listarFavoritos('')
      .then(response => {
        setListaDeFavoritos(response.data);
        montaLstFavoritos(response.data);
      })
      .catch(err => {
        console.error('Erro ao listar favoritos:', err);
      })
      .finally(() => setLoadingFavoritos(false));
  };

  const montaLstFavoritos = lstFavoritos => {
    const lstFavoritosFixados = [...lstFavoritos.slice(0, 3)];
    if (lstFavoritosFixados.length <= 0) {
      lstFavoritosFixados.push(SUBMENUS.ADICIONAR_TELAS);
    }

    const qtdFavoritos = lstFavoritosFixados.length + 1; // Este +1 é referente ao CONTROLE_PAGAMENTOS
    setControleTamanho(qtdFavoritos === 2 ? 6 : qtdFavoritos === 3 ? 4 : 3);
    setListaDeFavoritos(lstFavoritosFixados.slice(0, 4));
  };

  const options = [
    { descricao: 'Defina suas contas bancárias (conta corrente e cobrança)', icone: carteiraHome },
    { descricao: 'Ajuste condições operacionais', icone: moneyHome },
    { descricao: 'Revise dados contábeis', icone: dadosHome },
    { descricao: 'Assine documentos pendentes', icone: docHome }
  ];

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const mostraCapitalFlow = Boolean(
    escopoAcesso?.plataforma_oneshell?.componente['jornada-capital-flow']
  );
  const mostraDashboardFinanceiro = Boolean(
    escopoAcesso?.plataforma_oneshell?.componente['dashboard-financeiro']
  );

  const normalizarEmpresasDashboard = empresas =>
    (empresas ?? [])
      .map(empresa => {
        const id = empresa?.id ?? empresa?.codigo ?? empresa?.codEmpresa ?? empresa?.CODEMPRESA;
        const nome = empresa?.nome ?? empresa?.razaoSocial ?? empresa?.NOMEEMPRESA;
        const label = empresa?.label ?? `${id} - ${nome ?? ''}`.trim();

        if (!id || !nome) return null;

        return {
          id,
          nome,
          label,
          cpfcnpjTitular: empresa?.cnpj ?? '',
          boletosPendentes: {
            loading: false,
            quantidade: 0,
            valor: 0,
            cnpjEmpresa: ''
          },
          bancos: []
        };
      })
      .filter(Boolean);

  const formatarContaComDigito = (conta, digito) => {
    if (!conta) return '';
    if (!digito) return String(conta);

    return `${conta}-${digito}`;
  };

  const formatarAgenciaComDigito = (agencia, digito) => {
    if (!agencia) return '';
    if (!digito) return String(agencia);

    return `${agencia}-${digito}`;
  };

  const normalizarBancosAgenciasDashboard = bancos =>
    (bancos ?? []).map(banco => ({
      id: banco?.CODCONTACOBRANCA ?? `${banco?.BANCO ?? 'banco'}-${banco?.CODAGENCIA ?? ''}`,
      banco: banco?.BANCO ?? '',
      cod_banco: banco?.CODBANCO ?? null,
      agencia: formatarAgenciaComDigito(banco?.CODAGENCIA, banco?.DIGAGENCIA),
      conta: formatarContaComDigito(banco?.CODCC, banco?.DIGCC),
      carteira: banco?.CARTEIRA ?? '',
      cod_conta_cobranca: banco?.CODCONTACOBRANCA ?? null,
      cod_empresa: banco?.CODEMPRESA ?? null,
      cobranca_escrow: banco?.COBRANCAESCROW ?? 'N',
      principal_boleto: banco?.PRINCIPALBOLETO ?? 'N',
      cod_conta_corranca_tipos: banco?.CODCONTACORRENTECOBRANCATIPOS ?? 0,
      troca_carteira: banco?.TROCACARTEIRA ?? 'N',
      titulos: 0,
      instrucoesPendentes: {
        loading: true,
        carregamentoIniciado: false,
        quantidade: 0,
        escrow: banco?.COBRANCAESCROW ?? 'N'
      },
      remessasPendentes: {
        loading: true,
        carregamentoIniciado: false,
        quantidade: 0
      }
    }));

  const normalizarBoletosPendentesDashboard = boletos => ({
    loading: false,
    quantidade: boletos?.QTD_BOLETOS ?? 0,
    valor: parseFloat(boletos?.VALOR_BOLETOS ?? 0).toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }),
    cnpjEmpresa: boletos?.CNPJ_EMPRESA ?? ''
  });

  const normalizarInstrucoesPendentesDashboard = instrucoes => ({
    loading: false,
    carregamentoIniciado: true,
    quantidade: instrucoes?.QTD_INSTRUCOES ?? 0,
    escrow: instrucoes?.ESCROW ?? 'N'
  });

  const normalizarRemessasPendentesDashboard = remessas => ({
    loading: false,
    carregamentoIniciado: true,
    quantidade: remessas?.QTD_OPERACOES ?? 0
  });

  const buscarDadosDashboardEmpresa = empresa => {
    if (!empresa?.id) return;

    setDashboardEmpresasCarregando(prevState => ({
      ...prevState,
      [empresa.id]: true
    }));

    setEmpresasDashboardHome(prevState =>
      prevState.map(item =>
        String(item.id) !== String(empresa.id)
          ? item
          : {
              ...item,
              boletosPendentes: {
                ...(item.boletosPendentes ?? {}),
                loading: Boolean(item.cpfcnpjTitular)
              }
            }
      )
    );

    const promiseBancos = getBancosAgenciasFinanceiro(empresa.id)
      .then(responseBancos => {
        setEmpresasDashboardHome(prevState =>
          prevState.map(item =>
            String(item.id) !== String(empresa.id)
              ? item
              : {
                  ...item,
                  bancos: normalizarBancosAgenciasDashboard(responseBancos?.data ?? [])
                }
          )
        );
      })
      .catch(err => {
        console.error(`Erro ao buscar bancos e agências da empresa ${empresa.id}`, err);
        setEmpresasDashboardHome(prevState =>
          prevState.map(item =>
            String(item.id) !== String(empresa.id)
              ? item
              : {
                  ...item,
                  bancos: []
                }
          )
        );
      });

    const promiseBoletos = empresa.cpfcnpjTitular
      ? getBoletosPendentesFinanceiro(empresa.cpfcnpjTitular)
          .then(responseBoletos => {
            setEmpresasDashboardHome(prevState =>
              prevState.map(item =>
                String(item.id) !== String(empresa.id)
                  ? item
                  : {
                      ...item,
                      boletosPendentes: normalizarBoletosPendentesDashboard(responseBoletos?.data ?? {})
                    }
              )
            );
          })
          .catch(err => {
            console.error(`Erro ao buscar boletos D+1 da empresa ${empresa.id}`, err);
            setEmpresasDashboardHome(prevState =>
              prevState.map(item =>
                String(item.id) !== String(empresa.id)
                  ? item
                  : {
                      ...item,
                      boletosPendentes: normalizarBoletosPendentesDashboard({})
                    }
              )
            );
          })
      : Promise.resolve().then(() => {
          setEmpresasDashboardHome(prevState =>
            prevState.map(item =>
              String(item.id) !== String(empresa.id)
                ? item
                : {
                    ...item,
                    boletosPendentes: normalizarBoletosPendentesDashboard({})
                  }
            )
          );
        });

    Promise.allSettled([promiseBancos, promiseBoletos])
      .then(() => {
        setDashboardEmpresasCarregadas(prevState => ({
          ...prevState,
          [empresa.id]: true
        }));
      })
      .finally(() => {
        setDashboardEmpresasCarregando(prevState => ({
          ...prevState,
          [empresa.id]: false
        }));
      });
  };

  useEffect(() => {
    if (!mostraDashboardFinanceiro) {
      setLoadingDashboardFinanceiro(false);
      setEmpresasDashboardHome([]);
      setEmpresasDashboardCarregadas(false);
      return;
    }

    setLoadingDashboardFinanceiro(true);
    setEmpresasDashboardCarregadas(false);
    getEmpresasDashboardFinanceiro()
      .then(response => {
        const empresas = normalizarEmpresasDashboard(response?.data ?? []);
        setEmpresasDashboardHome(empresas);
        setEmpresasDashboardCarregadas(false);

        if (empresas.length === 0) {
          setLoadingDashboardFinanceiro(false);
        }
      })
      .catch(err => {
        console.error('Erro ao buscar empresas do financeiro', err);
        setEmpresasDashboardHome([]);
        setEmpresasDashboardCarregadas(false);
        setLoadingDashboardFinanceiro(false);
      });
  }, [mostraDashboardFinanceiro]);

  useEffect(() => {
    if (!mostraDashboardFinanceiro || !empresasDashboardCarregadas) return;

    if (empresasDashboardHome.length === 0) {
      setLoadingDashboardFinanceiro(false);
      return;
    }

    setLoadingDashboardFinanceiro(true);
    Promise.all(
      empresasDashboardHome.map(empresa =>
        Promise.all([
          getBancosAgenciasFinanceiro(empresa.id).catch(err => {
            console.error(`Erro ao buscar bancos e agências da empresa ${empresa.id}`, err);
            return { data: [] };
          }),
          empresa.cpfcnpjTitular
            ? getBoletosPendentesFinanceiro(empresa.cpfcnpjTitular).catch(err => {
                console.error(`Erro ao buscar boletos D+1 da empresa ${empresa.id}`, err);
                return { data: {} };
              })
            : Promise.resolve({ data: {} })
        ])
          .then(([responseBancos, responseBoletos]) => ({
            id: empresa.id,
            bancos: normalizarBancosAgenciasDashboard(responseBancos?.data ?? []),
            boletosPendentes: normalizarBoletosPendentesDashboard(responseBoletos?.data ?? {})
          }))
          .catch(err => {
            console.error(`Erro ao montar dashboard financeiro da empresa ${empresa.id}`, err);
            return {
              id: empresa.id,
              bancos: [],
              boletosPendentes: normalizarBoletosPendentesDashboard({})
            };
          })
      )
    )
      .then(empresasComBancos => {
        setEmpresasDashboardHome(prevState =>
          prevState.map(empresa => {
            const empresaAtualizada = empresasComBancos.find(
              item => String(item.id) === String(empresa.id)
            );

            if (!empresaAtualizada) return empresa;

            return {
              ...empresa,
              bancos: empresaAtualizada.bancos ?? [],
              boletosPendentes:
                empresaAtualizada.boletosPendentes ?? normalizarBoletosPendentesDashboard({})
            };
          })
        );
      })
      .catch(err => {
        console.error('Erro ao buscar bancos e agências do financeiro', err);
        setEmpresasDashboardHome(prevState =>
          prevState.map(empresa => ({
            ...empresa,
            bancos: [],
            boletosPendentes: normalizarBoletosPendentesDashboard({})
          }))
        );
      })
      .finally(() => setLoadingDashboardFinanceiro(false));
  }, [mostraDashboardFinanceiro, empresasDashboardCarregadas]);

  useEffect(() => {
    const bancosPendentes = empresasDashboardHome.flatMap(empresa =>
      (empresa.bancos ?? [])
        .filter(
          banco =>
            banco?.instrucoesPendentes?.loading && !banco?.instrucoesPendentes?.carregamentoIniciado
        )
        .map(banco => ({
          idEmpresa: empresa.id,
          banco
        }))
    );

    if (bancosPendentes.length === 0) return;

    setEmpresasDashboardHome(prevState =>
      prevState.map(empresa => ({
        ...empresa,
        bancos: (empresa.bancos ?? []).map(item => {
          const bancoPendente = bancosPendentes.find(
            banco => String(banco.idEmpresa) === String(empresa.id) && banco.banco.id === item.id
          );

          if (!bancoPendente) return item;

          return {
            ...item,
            instrucoesPendentes: {
              ...item.instrucoesPendentes,
              carregamentoIniciado: true
            }
          };
        })
      }))
    );

    bancosPendentes.forEach(({ idEmpresa, banco }) => {
      if (!banco.cod_banco || !banco.cod_conta_cobranca) {
        setEmpresasDashboardHome(prevState =>
          prevState.map(empresa => ({
            ...empresa,
            bancos: (empresa.bancos ?? []).map(item =>
              item.id !== banco.id
                ? item
                : {
                    ...item,
                    titulos: 0,
                    instrucoesPendentes: normalizarInstrucoesPendentesDashboard({})
                  }
            )
          }))
        );
        return;
      }

      getInstrucoesPendentesFinanceiro({
        cod_banco: banco.cod_banco,
        cobranca_escrow: banco.cobranca_escrow ?? 'N',
        cod_conta_cobranca: banco.cod_conta_cobranca
      })
        .then(response => {
          const instrucoesPendentes = normalizarInstrucoesPendentesDashboard(response?.data ?? {});

          setEmpresasDashboardHome(prevState =>
            prevState.map(empresa => {
              if (String(empresa.id) !== String(idEmpresa)) return empresa;

              return {
                ...empresa,
                bancos: (empresa.bancos ?? []).map(item =>
                  item.id !== banco.id
                    ? item
                    : {
                        ...item,
                        titulos: instrucoesPendentes.quantidade,
                        instrucoesPendentes
                      }
                )
              };
            })
          );
        })
        .catch(err => {
          console.error(
            `Erro ao buscar instruções pendentes da conta cobrança ${banco.cod_conta_cobranca}`,
            err
          );

          setEmpresasDashboardHome(prevState =>
            prevState.map(empresa => {
              if (String(empresa.id) !== String(idEmpresa)) return empresa;

              return {
                ...empresa,
                bancos: (empresa.bancos ?? []).map(item =>
                  item.id !== banco.id
                    ? item
                    : {
                        ...item,
                        titulos: 0,
                        instrucoesPendentes: normalizarInstrucoesPendentesDashboard({})
                      }
                )
              };
            })
          );
        });
    });
  }, [empresasDashboardHome]);

  useEffect(() => {
    const bancosPendentesRemessas = empresasDashboardHome.flatMap(empresa =>
      (empresa.bancos ?? [])
        .filter(
          banco => banco?.remessasPendentes?.loading && !banco?.remessasPendentes?.carregamentoIniciado
        )
        .map(banco => ({
          idEmpresa: empresa.id,
          banco
        }))
    );

    if (bancosPendentesRemessas.length === 0) return;

    setEmpresasDashboardHome(prevState =>
      prevState.map(empresa => ({
        ...empresa,
        bancos: (empresa.bancos ?? []).map(item => {
          const bancoPendente = bancosPendentesRemessas.find(
            banco => String(banco.idEmpresa) === String(empresa.id) && banco.banco.id === item.id
          );

          if (!bancoPendente) return item;

          return {
            ...item,
            remessasPendentes: {
              ...item.remessasPendentes,
              carregamentoIniciado: true
            }
          };
        })
      }))
    );

    bancosPendentesRemessas.forEach(({ idEmpresa, banco }) => {
      getRemessasPendentesFinanceiro({
        cod_banco: banco.cod_banco ?? 0,
        carteira: parseInt(banco.carteira ?? 0, 10) || 0,
        principal_boleto: banco.principal_boleto ?? 'N',
        troca_carteira: banco?.troca_carteira ?? 'N',
        cod_conta_corranca_tipos: banco.cod_conta_corranca_tipos ?? 0,
        cobranca_escrow: banco.cobranca_escrow ?? 'N',
        cod_empresa: parseInt(banco.cod_empresa ?? idEmpresa, 10) || 0,
        cod_conta_cobranca: banco.cod_conta_cobranca ?? 0
      })
        .then(response => {
          const remessasPendentes = normalizarRemessasPendentesDashboard(response?.data ?? {});

          setEmpresasDashboardHome(prevState =>
            prevState.map(empresa => {
              if (String(empresa.id) !== String(idEmpresa)) return empresa;

              return {
                ...empresa,
                bancos: (empresa.bancos ?? []).map(item =>
                  item.id !== banco.id
                    ? item
                    : {
                        ...item,
                        remessasPendentes
                      }
                )
              };
            })
          );
        })
        .catch(err => {
          console.error(
            `Erro ao buscar remessas pendentes da conta cobrança ${banco.cod_conta_cobranca}`,
            err
          );

          setEmpresasDashboardHome(prevState =>
            prevState.map(empresa => {
              if (String(empresa.id) !== String(idEmpresa)) return empresa;

              return {
                ...empresa,
                bancos: (empresa.bancos ?? []).map(item =>
                  item.id !== banco.id
                    ? item
                    : {
                        ...item,
                        remessasPendentes: normalizarRemessasPendentesDashboard({})
                      }
                )
              };
            })
          );
        });
    });
  }, [empresasDashboardHome]);

  const qtdEmpresasDashboardAbertas = empresasDashboardHome.filter(
    empresa => dashboardEmpresasAbertas[empresa.id]
  ).length;

  const classeFundoHomeDashboard =
    mostraDashboardFinanceiro && qtdEmpresasDashboardAbertas >= 2
      ? 'ajuste-home-dashboard-expandido-2'
      : mostraDashboardFinanceiro && (qtdEmpresasDashboardAbertas === 1 || loadingDashboardFinanceiro)
        ? 'ajuste-home-dashboard-expandido-1'
        : '';

  const buscaValorLiberadoCapitalFlow = () => {
    if (!mostraCapitalFlow) return;

    formataValorLiberado(0);

    setLoadingValorLiberado(true);
    getValorLiberadoCapitalFlow()
      .then(response => {
        formataValorLiberado(response.data.limite_disponivel ?? 0);
      })
      .catch(err => {
        console.error('Erro ao buscar o valor liberado:', err);
      })
      .finally(() => setLoadingValorLiberado(false));
  };

  const formataValorLiberado = valor => {
    valor = parseFloat(valor).toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    setvalorSaldoLiberado(valor);
  };

  const navegarTelaCapitalFlow = (buscarDados = true) => {
    navigate('/capital-flow/nova-cessao', {
      state: { buscarDados: buscarDados }
    });
  };

  const buscaEtapaCapitalFlow = () => {
    if (loadingBuscaEtapa || loadingValorLiberado) return;
    setLoadingBuscaEtapa(true);
    getEtapaCapitalFlow()
      .then(response => {
        if (response.data?.ETAPA) {
          setOpenModalRecuperaCessao(true);
          setNomeEtapaCapitalFlow(etapasCapitalFlow(response.data.ETAPA));
          setEtapaSessionCapitalFlow(response.data.ETAPA);
        } else {
          comecarNovajornada();
        }
      })
      .catch(err => {
        console.error('Erro ao buscar informações da etapa', err);
      })
      .finally(() => setLoadingBuscaEtapa(false));
  };

  const handleCloseModalRecuperaCessao = () => {
    setOpenModalRecuperaCessao(false);
  };

  const comecarNovajornada = () => {
    deleteRegistrosTemporarios();
    setOpenModalRecuperaCessao(false);
    setEtapaSessionCapitalFlow('NovaCessao');
    navegarTelaCapitalFlow(false);
  };

  const etapasCapitalFlow = etapaCapitalFlow => {
    switch (etapaCapitalFlow) {
      case 'NovaCessao':
        return 'Simulação';
      case 'UploadCessao':
        return 'Envio dos arquivos';
      case 'ContaCorrenteCessao':
        return 'Seleção da conta corrente';
      default:
        return 'Nova cessão';
    }
  };

  const toggleDashboardEmpresa = idEmpresa => {
    const proximoEstadoAberto = !dashboardEmpresasAbertas[idEmpresa];

    setDashboardEmpresasAbertas(prevState => ({
      ...prevState,
      [idEmpresa]: proximoEstadoAberto
    }));

    if (!proximoEstadoAberto) return;
    if (dashboardEmpresasCarregadas[idEmpresa] || dashboardEmpresasCarregando[idEmpresa]) return;

    const empresa = empresasDashboardHome.find(item => String(item.id) === String(idEmpresa));
    buscarDadosDashboardEmpresa(empresa);
  };

  const recarregarDashboardEmpresa = idEmpresa => {
    if (dashboardEmpresasCarregando[idEmpresa]) return;

    const empresa = empresasDashboardHome.find(item => String(item.id) === String(idEmpresa));
    if (!empresa) return;

    setDashboardEmpresasCarregadas(prevState => ({
      ...prevState,
      [idEmpresa]: false
    }));

    buscarDadosDashboardEmpresa(empresa);
  };

  const setarParametrosFinanceiro = (codEmpresa, codContaCobranca) => {
    sessionStorage.setItem(
      'dados_remessa',
      JSON.stringify({ codEmpresa: codEmpresa, codContaCobranca: codContaCobranca })
    );
  };

  return {
    refNomeRef,
    esperandoValor,
    isPendingSaldo,
    options,
    listaDeFavoritos,
    loadingFavoritos,
    permissaoTelaPagamentos,
    openAlert,
    setOpenAlert,
    handleClose,
    controleTamanho,
    valorSaldoOperar,
    valorSaldoLiberado,
    mostraCapitalFlow,
    mostraDashboardFinanceiro,
    loadingDashboardFinanceiro,
    navegarTelaCapitalFlow,
    isPendingValorOperado,
    valorSaldoOperado,
    qtdPendencias,
    isPendingQtdPendencias,
    nivelUsuario,
    loadingValorLiberado,
    loadingBuscaEtapa,
    openModalRecuperaCessao,
    buscaEtapaCapitalFlow,
    nomeEtapaCapitalFlow,
    comecarNovajornada,
    handleCloseModalRecuperaCessao,
    empresasDashboardHome,
    dashboardEmpresasAbertas,
    dashboardEmpresasCarregando,
    toggleDashboardEmpresa,
    recarregarDashboardEmpresa,
    classeFundoHomeDashboard,
    setarParametrosFinanceiro
  };
};

export default useHomeHook;
